<template>
  <div class="text-black text-base overflow-hidden max-w-screen" :dir="localeStore.direction">
    <main class="container mx-auto px-4 md:px-8">
      <router-view></router-view>
    </main>
  </div>
</template>

<script setup>
import axios from 'axios'
import { useLocaleStore } from '@/stores/locale'

const localeStore = useLocaleStore()

axios.defaults.baseURL = import.meta.env.VITE_HOST + '/api'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.allowAbsoluteUrls = true
</script>

<style>
@import url('@wikimedia/codex-design-tokens/dist/theme-wikimedia-ui-root.css');
@import url('@wikimedia/codex/dist/codex.style.css');

header {
  display: flex;
  flex-direction: row;

  font-size: larger;
}

main {
  margin: auto;
  display: flex;
  flex-direction: column;
}
</style>
